import api from '../../services/api';

// Action types
export const GOLDSMITH_ACTION_TYPES = {
  // Goldsmith actions
  GET_GOLDSMITHS_REQUEST: 'GET_GOLDSMITHS_REQUEST',
  GET_GOLDSMITHS_SUCCESS: 'GET_GOLDSMITHS_SUCCESS',
  GET_GOLDSMITHS_FAILURE: 'GET_GOLDSMITHS_FAILURE',
  
  GET_GOLDSMITH_BY_ID_REQUEST: 'GET_GOLDSMITH_BY_ID_REQUEST',
  GET_GOLDSMITH_BY_ID_SUCCESS: 'GET_GOLDSMITH_BY_ID_SUCCESS',
  GET_GOLDSMITH_BY_ID_FAILURE: 'GET_GOLDSMITH_BY_ID_FAILURE',
  
  CREATE_GOLDSMITH_REQUEST: 'CREATE_GOLDSMITH_REQUEST',
  CREATE_GOLDSMITH_SUCCESS: 'CREATE_GOLDSMITH_SUCCESS',
  CREATE_GOLDSMITH_FAILURE: 'CREATE_GOLDSMITH_FAILURE',
  
  UPDATE_GOLDSMITH_REQUEST: 'UPDATE_GOLDSMITH_REQUEST',
  UPDATE_GOLDSMITH_SUCCESS: 'UPDATE_GOLDSMITH_SUCCESS',
  UPDATE_GOLDSMITH_FAILURE: 'UPDATE_GOLDSMITH_FAILURE',
  
  DELETE_GOLDSMITH_REQUEST: 'DELETE_GOLDSMITH_REQUEST',
  DELETE_GOLDSMITH_SUCCESS: 'DELETE_GOLDSMITH_SUCCESS',
  DELETE_GOLDSMITH_FAILURE: 'DELETE_GOLDSMITH_FAILURE',
  
  GET_GOLDSMITH_ACCOUNT_REQUEST: 'GET_GOLDSMITH_ACCOUNT_REQUEST',
  GET_GOLDSMITH_ACCOUNT_SUCCESS: 'GET_GOLDSMITH_ACCOUNT_SUCCESS',
  GET_GOLDSMITH_ACCOUNT_FAILURE: 'GET_GOLDSMITH_ACCOUNT_FAILURE',
  
  // Customer Order actions
  GET_CUSTOMER_ORDERS_REQUEST: 'GET_CUSTOMER_ORDERS_REQUEST',
  GET_CUSTOMER_ORDERS_SUCCESS: 'GET_CUSTOMER_ORDERS_SUCCESS',
  GET_CUSTOMER_ORDERS_FAILURE: 'GET_CUSTOMER_ORDERS_FAILURE',
  
  GET_ORDER_BY_ID_REQUEST: 'GET_ORDER_BY_ID_REQUEST',
  GET_ORDER_BY_ID_SUCCESS: 'GET_ORDER_BY_ID_SUCCESS',
  GET_ORDER_BY_ID_FAILURE: 'GET_ORDER_BY_ID_FAILURE',
  
  CREATE_CUSTOMER_ORDER_REQUEST: 'CREATE_CUSTOMER_ORDER_REQUEST',
  CREATE_CUSTOMER_ORDER_SUCCESS: 'CREATE_CUSTOMER_ORDER_SUCCESS',
  CREATE_CUSTOMER_ORDER_FAILURE: 'CREATE_CUSTOMER_ORDER_FAILURE',
  
  UPDATE_CUSTOMER_ORDER_REQUEST: 'UPDATE_CUSTOMER_ORDER_REQUEST',
  UPDATE_CUSTOMER_ORDER_SUCCESS: 'UPDATE_CUSTOMER_ORDER_SUCCESS',
  UPDATE_CUSTOMER_ORDER_FAILURE: 'UPDATE_CUSTOMER_ORDER_FAILURE',
  
  ASSIGN_GOLDSMITH_REQUEST: 'ASSIGN_GOLDSMITH_REQUEST',
  ASSIGN_GOLDSMITH_SUCCESS: 'ASSIGN_GOLDSMITH_SUCCESS',
  ASSIGN_GOLDSMITH_FAILURE: 'ASSIGN_GOLDSMITH_FAILURE',
  
  ADD_ORDER_PAYMENT_REQUEST: 'ADD_ORDER_PAYMENT_REQUEST',
  ADD_ORDER_PAYMENT_SUCCESS: 'ADD_ORDER_PAYMENT_SUCCESS',
  ADD_ORDER_PAYMENT_FAILURE: 'ADD_ORDER_PAYMENT_FAILURE',
  
  // Purchase actions
  GET_PURCHASES_REQUEST: 'GET_PURCHASES_REQUEST',
  GET_PURCHASES_SUCCESS: 'GET_PURCHASES_SUCCESS',
  GET_PURCHASES_FAILURE: 'GET_PURCHASES_FAILURE',
  
  GET_PURCHASE_BY_ID_REQUEST: 'GET_PURCHASE_BY_ID_REQUEST',
  GET_PURCHASE_BY_ID_SUCCESS: 'GET_PURCHASE_BY_ID_SUCCESS',
  GET_PURCHASE_BY_ID_FAILURE: 'GET_PURCHASE_BY_ID_FAILURE',
  
  CREATE_PURCHASE_REQUEST: 'CREATE_PURCHASE_REQUEST',
  CREATE_PURCHASE_SUCCESS: 'CREATE_PURCHASE_SUCCESS',
  CREATE_PURCHASE_FAILURE: 'CREATE_PURCHASE_FAILURE',
  
  UPDATE_PURCHASE_REQUEST: 'UPDATE_PURCHASE_REQUEST',
  UPDATE_PURCHASE_SUCCESS: 'UPDATE_PURCHASE_SUCCESS',
  UPDATE_PURCHASE_FAILURE: 'UPDATE_PURCHASE_FAILURE',
  
  GET_GOLD_RATE_REQUEST: 'GET_GOLD_RATE_REQUEST',
  GET_GOLD_RATE_SUCCESS: 'GET_GOLD_RATE_SUCCESS',
  GET_GOLD_RATE_FAILURE: 'GET_GOLD_RATE_FAILURE',
};

// Goldsmith Actions
export const getGoldsmiths = (params = {}) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITHS_REQUEST });
  try {
    const response = await api.get('/goldsmiths', { params });
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITHS_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITHS_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const getGoldsmithById = (id) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_BY_ID_REQUEST });
  try {
    const response = await api.get(`/goldsmiths/${id}`);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_BY_ID_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_BY_ID_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const createGoldsmith = (goldsmithData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.CREATE_GOLDSMITH_REQUEST });
  try {
    const response = await api.post('/goldsmiths', goldsmithData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.CREATE_GOLDSMITH_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.CREATE_GOLDSMITH_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const updateGoldsmith = (id, goldsmithData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.UPDATE_GOLDSMITH_REQUEST });
  try {
    const response = await api.put(`/goldsmiths/${id}`, goldsmithData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.UPDATE_GOLDSMITH_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.UPDATE_GOLDSMITH_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const deleteGoldsmith = (id) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.DELETE_GOLDSMITH_REQUEST });
  try {
    const response = await api.delete(`/goldsmiths/${id}`);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.DELETE_GOLDSMITH_SUCCESS,
      payload: id
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.DELETE_GOLDSMITH_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const getGoldsmithAccountSummary = (id, params = {}) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_ACCOUNT_REQUEST });
  try {
    const response = await api.get(`/goldsmiths/${id}/account-summary`, { params });
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_ACCOUNT_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_ACCOUNT_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// Customer Order Actions
export const getCustomerOrders = (params = {}) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_CUSTOMER_ORDERS_REQUEST });
  try {
    const response = await api.get('/customer-orders', { params });
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_CUSTOMER_ORDERS_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_CUSTOMER_ORDERS_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const getOrderById = (id) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_REQUEST });
  try {
    const response = await api.get(`/customer-orders/${id}`);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const createCustomerOrder = (orderData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.CREATE_CUSTOMER_ORDER_REQUEST });
  try {
    const response = await api.post('/customer-orders', orderData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.CREATE_CUSTOMER_ORDER_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.CREATE_CUSTOMER_ORDER_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const getCustomerOrderById = (id) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_REQUEST });
  try {
    const response = await api.get(`/customer-orders/${id}`);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const updateCustomerOrder = (id, orderData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.UPDATE_CUSTOMER_ORDER_REQUEST });
  try {
    const response = await api.put(`/customer-orders/${id}`, orderData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.UPDATE_CUSTOMER_ORDER_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.UPDATE_CUSTOMER_ORDER_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const assignGoldsmithToOrder = (orderId, goldsmithId) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.ASSIGN_GOLDSMITH_REQUEST });
  try {
    const response = await api.post(`/customer-orders/${orderId}/assign-goldsmith`, {
      goldsmith_id: goldsmithId
    });
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.ASSIGN_GOLDSMITH_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.ASSIGN_GOLDSMITH_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const addOrderPayment = (orderId, paymentData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.ADD_ORDER_PAYMENT_REQUEST });
  try {
    const response = await api.post(`/customer-orders/${orderId}/payment`, paymentData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.ADD_ORDER_PAYMENT_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.ADD_ORDER_PAYMENT_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// Purchase Actions
export const getGoldsmithPurchases = (params = {}) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_PURCHASES_REQUEST });
  try {
    const response = await api.get('/goldsmith-purchases', { params });
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_PURCHASES_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_PURCHASES_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const getPurchaseById = (id) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_PURCHASE_BY_ID_REQUEST });
  try {
    const response = await api.get(`/goldsmith-purchases/${id}`);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_PURCHASE_BY_ID_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_PURCHASE_BY_ID_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const createGoldsmithPurchase = (purchaseData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.CREATE_PURCHASE_REQUEST });
  try {
    const response = await api.post('/goldsmith-purchases', purchaseData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.CREATE_PURCHASE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.CREATE_PURCHASE_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const updateGoldsmithPurchase = (id, purchaseData) => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.UPDATE_PURCHASE_REQUEST });
  try {
    const response = await api.put(`/goldsmith-purchases/${id}`, purchaseData);
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.UPDATE_PURCHASE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.UPDATE_PURCHASE_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

export const getTodayGoldRate = () => async (dispatch) => {
  dispatch({ type: GOLDSMITH_ACTION_TYPES.GET_GOLD_RATE_REQUEST });
  try {
    const response = await api.get('/goldsmith-purchases/utils/gold-rate');
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLD_RATE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GOLDSMITH_ACTION_TYPES.GET_GOLD_RATE_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// Settle goldsmith purchase (pure/amount/mixed)
export const settleGoldsmithPurchase = (id, payload) => async () => {
  try {
    const response = await api.post(`/goldsmith-purchases/${id}/settlements`, payload);
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to settle goldsmith purchase';
    return { success: false, message };
  }
};

// Create goldsmith account adjustment (issue/receive without bill)
export const createGoldsmithAdjustment = (payload) => async () => {
  try {
    const response = await api.post('/goldsmith-purchases/accounts/adjustments', payload);
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create goldsmith adjustment';
    return { success: false, message };
  }
};